<template>
  <div
    class="package"
    :class="type == 'center' ? 'center-style' : type == 'side-left' ? 'sides-style-left' : 'sides-style-right'"
  >
    <div class="img-popular" v-if="type == 'center'"></div>
    <div class="package__title" :class="type == 'center' ? 'center-margin-title-package' : ''">{{ title }}</div>
    <div class="package__sep"></div>
    <div class="package__subtitle" :class="type == 'center' ? 'center-margin-subtitle-package' : ''">
      {{ subtitle }}
    </div>
    <div class="package__description">
      <div class="package__description__item not-margin">
        <div class="package__description__item__contimg"><img src="/images/green_arrow.png" /></div>
        <div class="package__description__item__text" :class="type == 'center' ? 'center-package-text-color' : ''">
          <span class="bold-text">{{ nummin }}</span>
          segundos de videos (aprox. {{ numvideos }} videos)
        </div>
      </div>
      <div class="package__description__item">
        <div class="package__description__item__contimg"><img src="/images/green_arrow.png" /></div>
        <div class="package__description__item__text" :class="type == 'center' ? 'center-package-text-color' : ''">
          Calidad de video:&nbsp;&nbsp;<span class="bold-text">{{ calidad }}</span>
        </div>
      </div>
      <div class="package__description__item">
        <div class="package__description__item__contimg">
          <img src="/images/green_arrow.png" />
        </div>
        <div class="package__description__item__text" :class="type == 'center' ? 'center-package-text-color' : ''">
          Acceso a todas las herramientas premium para aficionados
        </div>
      </div>
    </div>
    <div class="package__price">
      <div class="package__price__normal">
        <span class="sign" :class="type == 'center' ? 'center-price-text-color' : ''">$</span>
        <span class="numprice" :class="type == 'center' ? 'center-price-text-color' : ''">{{ price }}</span>
        <span class="currency" :class="type == 'center' ? 'center-price-text-color' : ''">MXM</span>
        <span class="typebuy" :class="type == 'center' ? 'center-price-text-color-2' : ''"
          ><template v-if="isanual">&nbsp;al mes</template><template v-else>&nbsp;al año</template></span
        >
      </div>
      <!-- <div class="package__price__code">
        <span class="strike-price" :class="type == 'center' ? 'center-price-text-color' : ''"
          ><Strike>MX${{ pricedesc }}</Strike></span
        >
        <span class="item-desc-code" :class="type == 'center' ? 'item-desc-code-color' : ''"
          >-{{ desc }}% de Hirving Lozano</span
        >
      </div> -->
    </div>
    <div class="package__boton" :class="type == 'center' ? 'center-boton-style' : ''" @click="clickSelectPlan(title)">
      Seleccionar Plan
    </div>
  </div>
</template>
<script>
export default {
  name: 'Package',
  components: {},
  props: {
    type: {
      type: String,
      default: 'side',
    },
    title: {
      type: String,
      default: 'crack',
    },
    subtitle: {
      type: String,
      default: 'Para los aficionados casuales',
    },
    nummin: {
      type: String,
      default: '',
    },
    numvideos: {
      type: String,
      default: '',
    },
    calidad: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      default: '',
    },
    pricedesc: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    isanual: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    clickSelectPlan(type) {
      this.$emit('selectplan', type);
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.img-popular {
  width: 80px;
  height: 80px;
  position: absolute;
  background-image: url('/images/banda_popular.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  right: 0;
}
.center-price-text-color {
  color: white !important;
}
.center-price-text-color-2 {
  color: rgba(255, 255, 255, 0.62) !important;
}
.item-desc-code-color {
  background: none !important;
  color: white !important;
}
.item-desc-code {
  width: 136px;
  height: 18px;
  border-radius: 15px;
  background-color: #d2f894;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 18px;
  letter-spacing: normal;
  text-align: center;
  color: #132739;
  font-family: 'Avenir-Regular';
  padding: 1px 10px 1px 10px;
  border: 1px solid #d2f894;
  margin-left: 10px;
}
.strike-price {
  font-family: 'Avenir-Regular';
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: 0.17px;
  text-align: left;
  color: #000;
  @media screen and (max-width: 915px) {
    font-size: 15px;
  }
  @media screen and (max-width: 768px) {
    font-size: 17px;
  }
}
.sign {
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  font-family: 'Avenir-Demi';
  letter-spacing: -0.56px;
  text-align: left;
  color: #000;
  @media screen and (max-width: 915px) {
    font-size: 25px;
  }
  @media screen and (max-width: 768px) {
    font-size: 30px;
  }
}
.numprice {
  font-size: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  font-family: 'Avenir-Bold';
  letter-spacing: -0.56px;
  text-align: left;
  color: #000;
  @media screen and (max-width: 915px) {
    font-size: 32px;
  }
  @media screen and (max-width: 768px) {
    font-size: 40px;
  }
}
.currency {
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  font-family: 'Avenir-Demi';
  letter-spacing: -0.56px;
  text-align: left;
  color: #000;
  @media screen and (max-width: 915px) {
    font-size: 25px;
  }
  @media screen and (max-width: 768px) {
    font-size: 28px;
  }
}
.typebuy {
  font-size: 16px;
  font-weight: normal;
  font-family: 'Avenir-Demi';
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 0.16px;
  text-align: left;
  color: rgba(0, 0, 0, 0.62);
  @media screen and (max-width: 915px) {
    font-size: 14px;
  }
  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
}
.package {
  width: 365px;
  position: relative;
  @media screen and (max-width: 768px) {
    width: 93%;
    box-shadow: 20px 30px 60px 0 rgba(22, 29, 46, 0.24);
    background-color: #132839;
    margin: 0 auto;
  }
  &__title {
    height: 27px;
    width: 100%;
    font-size: 38px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 26px;
    font-family: 'Avenir-Bold';
    letter-spacing: 0.19px;
    text-align: left;
    color: #000;
    margin-top: 46px;
    text-align: center;
    @media screen and (max-width: 915px) {
      font-size: 36px;
    }
    @media screen and (max-width: 768px) {
      display: inline-block;
      margin-top: 46px !important;
    }
  }
  &__sep {
    width: 254px;
    height: 1px;
    border-bottom: 1px dashed #aaa9b6;
    display: inline-flex;
    align-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 30px;
    @media screen and (max-width: 915px) {
      width: 80%;
      margin-top: 15px;
      margin-bottom: 12px;
    }
    @media screen and (max-width: 768px) {
      width: 67%;
    }
    @media screen and (max-width: 460px) {
      margin-top: 12px;
      margin-bottom: 15px;
      width: 80%;
    }
  }
  &__subtitle {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: 0.14px;
    text-align: center;
    color: rgba(0, 0, 0, 0.62);
    @media screen and (max-width: 1115px) {
      font-size: 13px;
    }
    @media screen and (max-width: 915px) {
      font-size: 13px;
    }
    @media screen and (max-width: 460px) {
      font-size: 16px;
    }
    @media screen and (max-width: 360px) {
      font-size: 14px;
    }
  }
  &__description {
    width: 279px;
    height: auto;
    margin: 0 auto;
    margin-top: 28px;
    @media screen and (max-width: 1115px) {
      width: 85%;
    }
    @media screen and (max-width: 1015px) {
      width: 83%;
    }
    @media screen and (max-width: 915px) {
      width: 82%;
    }
    @media screen and (max-width: 768px) {
      width: 68%;
    }
    @media screen and (max-width: 460px) {
      width: 68%;
      margin-top: 16px;
    }
    @media screen and (max-width: 400px) {
      width: 74%;
    }
    @media screen and (max-width: 380px) {
      width: 80%;
    }
    @media screen and (max-width: 350px) {
      width: 85%;
    }
    &__item {
      width: 100%;
      height: auto;
      display: inline-flex;
      margin-top: 16px;
      @media screen and (max-width: 915px) {
        margin-top: 12px;
      }
      @media screen and (max-width: 460px) {
        margin-top: 9px;
      }
      &__contimg {
        width: 20px;
        height: auto;
      }
      &__text {
        width: 259px;
        height: auto;
        text-align: left;
        font-size: 16px;
        margin-left: 10px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        letter-spacing: -0.16px;
        text-align: left;
        color: #000;
        font-family: 'Avenir-Medium';
        @media screen and (max-width: 915px) {
          width: 100%;
          font-size: 15px;
        }
        @media screen and (max-width: 815px) {
          font-size: 14px;
        }
        @media screen and (max-width: 768px) {
          width: 100%;
          font-size: 16px;
        }
        @media screen and (max-width: 460px) {
          font-size: 15px;
          margin-left: 6px;
        }
      }
    }
  }
  &__price {
    width: 279px;
    height: auto;
    margin: 0 auto;
    margin-top: 28px;
    @media screen and (max-width: 1015px) {
      width: fit-content;
    }
    @media screen and (max-width: 915px) {
      width: fit-content;
    }
    @media screen and (max-width: 768px) {
      width: fit-content;
      margin-top: 78px;
    }
    @media screen and (max-width: 660px) {
      margin-top: 48px;
    }
    @media screen and (max-width: 480px) {
      width: fit-content;
      margin-top: 28px;
    }

    &__normal {
      text-align: left;
    }
    &__code {
      text-align: left;
    }
  }
  &__boton {
    width: 272px;
    height: 53px;
    border-radius: 30px;
    background-color: white;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    border: solid 1px #000;
    margin-top: 28px;
    font-size: 19px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    font-family: 'Avenir-Regular';
    line-height: 53px;
    letter-spacing: 0.19px;
    text-align: center;
    color: #000;
    @media screen and (max-width: 1015px) {
      width: 80%;
    }
    @media screen and (max-width: 915px) {
      width: 86%;
    }
    @media screen and (max-width: 768px) {
      width: 64%;
    }
    @media screen and (max-width: 480px) {
      width: 72%;
    }
    @media screen and (max-width: 380px) {
      border-radius: 53px;
    }
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
}
.center-boton-style {
  background-color: #cbee6b;
  font-family: 'Avenir-Medium';
  border: 0;
}
.bold-text {
  font-family: 'Avenir-Bold';
}
.center-package-text-color {
  color: white !important;
}
.sides-style-left {
  margin-top: 37px;
  height: 562px;
  box-shadow: 0 20px 40px 0 rgba(25, 35, 51, 0.15);
  background: white;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;

  @media screen and (max-width: 768px) {
    margin-top: 0px;
    border-radius: 24px;
    height: 600px;
  }
  @media screen and (max-width: 460px) {
    margin-top: 0px;
    border-radius: 24px;
    height: 543px;
  }
}
.sides-style-right {
  margin-top: 37px;
  height: 562px;
  box-shadow: 0 20px 40px 0 rgba(25, 35, 51, 0.15);
  background: white;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  @media screen and (max-width: 768px) {
    margin-top: 0px;
    border-radius: 24px;
    height: 600px;
  }
  @media screen and (max-width: 460px) {
    margin-top: 0px;
    border-radius: 24px;
    height: 543px;
  }
}
.center-style {
  height: 637px;
  margin-top: 0px;
  background-color: #132839;
  box-shadow: 0 20px 40px 0 rgba(25, 35, 51, 0.15);
  border-radius: 24px;
  @media screen and (max-width: 460px) {
    margin-top: 0px;
    border-radius: 24px;
    height: 543px;
  }
}
.center-margin-title-package {
  margin-top: 83px;
  color: white !important;
  @media screen and (max-width: 768px) {
    margin-top: 0px;
  }
}
.center-margin-subtitle-package {
  color: rgba(255, 255, 255, 0.62);
}
.not-margin {
  margin-top: 0px !important;
}
</style>
